import React from 'react';
import { Col, Form, FormGroup, FormControl, ControlLabel, HelpBlock, Button, Tabs, Tab } from 'react-bootstrap';
import DatePicker from 'react-bootstrap-date-picker';
import Scroll from 'react-scroll';
import rest from 'rest';

import { REST_API_URL, APP_PATH } from "../../Utils/Global";
import { getDateFromString, getIsoStringFromDate, getStringFromDate } from "../../Utils/Date";
import { cloneObject } from "../../Utils/Utils";

import Combobox from '../Helper/Combobox';
import Status from '../Helper/Status';

import AbstractEntity from './AbstractEntity';
import ValeurImport from './ValeurImport';

class Valeur extends AbstractEntity {
  /**
  * props
  * mode : readonly/add/edit
  * path : rest api path for the object's type
  * objectPath : rest api path for the object
  * data.object : instance data
  **/

  /**
  * getClassName
  * Returns the class name as String (once bundled the class name changes)
  **/
  static getClassName() {
    return "Valeur";
  }

  constructor(props) {
    super(props);



  }

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {

    if(this.state.object === undefined) {
        return null;
    }

    // Transforms date fields
    let dateObservation = null;

    if(this.state.object !== undefined) {
      if(this.state.object.dateObservation) {
        dateObservation = this.state.object.dateObservation;

        if(typeof dateObservation === "string") {
          dateObservation = getDateFromString(dateObservation);
        }
        dateObservation = getIsoStringFromDate(dateObservation);
      }
    }

    // Form status information
    const status = <Status parent={this} type={this.state.status.type} message={this.state.status.message} />;

    const historyBack = <Button bsStyle="link" onClick={this.props.modal ? this.props.closeModal : this.goBack} className="btnBack"><span className="glyphicon glyphicon-arrow-left" /> Retour</Button>;

    // Rendering the view
		let valeurForm =
      <div>
        {/* Status information */}
        {status}
        {historyBack}

  			<Form horizontal onSubmit={this.handleSubmit}>
          <HelpBlock>Formulaire de la valeur.</HelpBlock>

          {/* Form content */}
          <FormGroup controlId="idValeur" className="customHidden">
            <Col componentClass={ControlLabel} sm={2}>Identifiant</Col>
            <Col sm={1}><FormControl type="text" value={this.getObjectProperty("idValeur")} disabled="true" /></Col>
          </FormGroup>

          <FormGroup controlId="titre">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Titre</ControlLabel></Col>
            <Col componentClass={ControlLabel} sm={6}><FormControl type="text" onChange={this.handleChange} value={this.getObjectProperty("titre")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="dateObservation">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Date d'observation</ControlLabel></Col>
            <Col sm={2}><DatePicker dateFormat="DD/MM/YYYY" value={dateObservation} onChange={this.handleDateObservationChange.bind(this)} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          {/* Observation OneToMany */}
          <FormGroup controlId="idObservation" validationState={this.getRequiredFieldValidationState("idObservation")} >
            <Col componentClass={ControlLabel} sm={2}>Observation</Col>
            <Col sm={6}><Combobox url={this.getObservationPath()} optionValueKey="idObservation" optionLabelKey="titre"
              onChange={this.onObservationSelect.bind(this)} enableSearch={true}
              placeholder="Choisir une observation" default={this.getObjectProperty("idObservation")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          {/* Station OneToMany */}
          <FormGroup controlId="idStation" validationState={this.getRequiredFieldValidationState("idStation")} >
            <Col componentClass={ControlLabel} sm={2}>Station</Col>
            <Col sm={6}><Combobox url={this.getStationPath()} optionValueKey="idStation" optionLabelKey="nom" onChange={this.onStationSelect.bind(this)}
              enableSearch={true} placeholder="Choisir une station" default={this.getObjectProperty("idStation")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="valeurObservation">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Valeur de l'observation</ControlLabel></Col>
            <Col componentClass={ControlLabel} sm={6}><FormControl type="text" onChange={this.handleChange} value={this.getObjectProperty("valeurObservation")}
              disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="referenceDocument">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Référence au document</ControlLabel></Col>
            <Col componentClass={ControlLabel} sm={6}><FormControl type="text" onChange={this.handleChange} value={this.getObjectProperty("referenceDocument")}
              disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="commentaire">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Commentaire</ControlLabel></Col>
            <Col componentClass={ControlLabel} sm={6}><FormControl onChange={this.handleChange} componentClass="textarea" rows="5" value={this.getObjectProperty("commentaire")}
              disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          {/* Submit button */}
          {this.state.mode !== "readonly" ?
            <FormGroup>
              <Col smOffset={7} sm={1}>
                <Button bsStyle="success" type="submit">Sauvegarder</Button>
              </Col>
            </FormGroup> : ""
          }
  			</Form>

      </div>;

    if(this.state.mode === "add") {
      valeurForm =
      <Tabs defaultActiveKey={1} id="valeur-tabs">
        <Tab eventKey={1} title="Ajouter une valeur">{valeurForm}</Tab>
        <Tab eventKey={2} title="Import massif"><ValeurImport observationPath={this.getObservationPath()} /></Tab>
      </Tabs>;
    }

    return valeurForm;
	}

  /**
  * getStationPath
  * Returns the station path
  **/
  getStationPath() {
    console.log((this.getObjectProperty("idElementProjet") || this.props.match.params.idElementProjet));
    //const path = (this.state.mode === "add") ?
      //this.getObjectPath().replace("valeurs", "stations").replace("elementprojets", "elementprojets_stations") : "elementprojets_stations/" + (this.getObjectProperty("idElementProjet") || this.props.match.params.idElementProjet) + "/stations";

      const path = (this.state.mode === "add") ?
        this.getObjectPath().replace("valeurs", "stations").replace("elementprojets", "elementprojets_stations") : "elementprojets_stations/" + (this.getObjectProperty("idElementProjet") || this.props.match.params.idElementProjet) + "/stations";
    return REST_API_URL + path;
  }

  /**
  * getObservationPath
  * Returns the observation path
  **/
  getObservationPath() {
    const path = (this.state.mode === "add") ?
      this.getObjectPath().replace("valeurs", "observations") : "elementprojets/" + (this.getObjectProperty("idElementProjet") || this.props.match.params.idElementProjet) + "/observations";

    return REST_API_URL + path;
  }

  /**
  * getIdField
  * Returns the object idField
  **/
  getIdField() {
    return "idValeur";
  }

  /**
  * sendFormData
  * Saves the data
  **/
  sendFormData () {
    let method;
    let path = REST_API_URL + "valeurs/";

    if(this.state.mode === "edit") {
      method = "PUT";
      path += this.getObjectProperty("idValeur");
    } else if (this.state.mode === "add") {
      method = "POST";
    }

    let valeurObj = cloneObject(this.state.object);
    if (this.state.mode === "add") {
      valeurObj.idElementProjet=(this.getObjectProperty("idElementProjet") || this.props.match.params.idElementProjet);

    }
    let state = this.state;
    console.log('Valeurs');
    if(typeof valeurObj.dateObservation !== "string") {
      valeurObj.dateObservation = getStringFromDate(valeurObj.dateObservation);
    }

    // Validation des champs obligatoires
    if(this.getRequiredFieldValidationState("idObservation") === "error") {
      state.status = {
        type: 'danger',
        message: 'Choisir une observation dans la liste.'
      };
      this.setState(state);
      return;
    }

    if(this.getRequiredFieldValidationState("idStation") === "error") {
      state.status = {
        type: 'danger',
        message: 'Choisir une station dans la liste.'
      };
      this.setState(state);
      return;
    }

    Scroll.animateScroll.scrollToTop({
      duration: 1000,
      delay: 100,
      smooth: true
    });

    rest({
      method: method,
      path: path,
      entity: JSON.stringify(valeurObj),
      headers: {
  			'Content-Type': 'application/json'
  		}
    }).then(response => {
      if(response.status.code === 200) {
        this.saveGrids();
        this.setState({
          status: {
            type: 'success',
            message: 'Valeur sauvegardée.'
          },
          object: JSON.parse(response.entity)
        });
      } else if(response.status.code === 201) {
        const newObj = JSON.parse(response.entity);
        const state = {
          status: {
            type: 'success',
            message: 'Valeur créée.'
          },
          mode: 'edit',
          object: newObj
        };

        this.replaceHistory(APP_PATH + "/valeurs/" + newObj[this.getIdField()] + "/edit", state);

        if(this.props.onAdd) {
          this.props.onAdd.call(this, newObj);
        }
      } else {
        this.setState({
          status: {
            type: 'danger',
            message: 'Erreur de sauvegarde.'
          }
        });
      }
  	}, response => {
      this.setState({
        status: {
          type: 'danger',
          message: 'Problème d\'appel au serveur.'
        }
      });
		});
  }

  /**
  * saveGrids
  * Saves the ManyToMany components
  **/
  saveGrids() {
    if(this.refs.thematiquesGrid !== undefined) this.refs.thematiquesGrid.saveAll();
    if(this.refs.motclesGrid !== undefined) this.refs.motclesGrid.saveAll();
  }

  /**
  * onStationSelect
  * Modify the state idStation property from idStation Combobox change
  **/
  onStationSelect(station) {
    let objState = this.state;
    objState.object["idStation"] = (station) ? station.idStation : null;
    this.setState(objState);
  }

  /**
  * onObservationSelect
  * Modify the state idObservation property from idObservation Combobox change
  **/
  onObservationSelect(observation) {
    let objState = this.state;
    objState.object["idObservation"] = (observation) ? observation.idObservation : null;
    this.setState(objState);
  }

  /**
  * handleDateObservationChange
  * Modify the state dateDebut property from dateDebut field change
  **/
  handleDateObservationChange(dateString, formattedDate) {
    let objState = this.state;
    objState.object["dateObservation"] = (dateString !== null) ? new Date(dateString) : null;
    this.setState(objState);
  }

}

export default Valeur;



// WEBPACK FOOTER //
// ./src/views/Entity/Valeur.js